import { useTranslator } from "@eo-locale/react";

import {
  HStack,
  Text,
  Link,
  IconButton,
  FiTwitter,
  FiFacebook,
  AiOutlineGoogle
} from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

const SocialSignIn = (): JSX.Element => {
  const { translate } = useTranslator();
  const { participationConfigurations } = useAppSelector(
    (state) => state.participationConfigurations
  );

  const { googleEnabled, facebookEnabled, twitterEnabled } =
    participationConfigurations;

  if (!googleEnabled && !facebookEnabled && !twitterEnabled) return null;

  return (
    <HStack mt={4} justify="center">
      <Text>{translate("login.orContinueWith")}</Text>
      {googleEnabled && (
        <IconButton
          as={Link}
          isRound
          isExternal
          colorScheme="red"
          href="/auth/google_oauth2"
          icon={<AiOutlineGoogle />}
          aria-label={translate("common.socialMedia.google")}
        />
      )}
      {facebookEnabled && (
        <IconButton
          isRound
          as={Link}
          isExternal
          colorScheme="facebook"
          icon={<FiFacebook />}
          href="/auth/facebook"
          aria-label={translate("common.socialMedia.facebook")}
        />
      )}
      {twitterEnabled && (
        <IconButton
          isRound
          as={Link}
          isExternal
          colorScheme="twitter"
          icon={<FiTwitter />}
          href="/social_logins/twitter"
          aria-label={translate("common.socialMedia.twitter")}
        />
      )}
    </HStack>
  );
};

export default SocialSignIn;
